import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const InputValidIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="m14.703 4.71-9.19 9.097-4.216-4.172 1.406-1.422 2.81 2.78 7.784-7.704 1.406 1.422Z" />
  </IconWrapper>
)

export default InputValidIconSmall
